$(function () {
    $('#product_slider_01').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow prev-arrow">',
        nextArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow next-arrow">',
        responsive: [{
            breakpoint: 599,  //ブレイクポイントを指定
            settings: {
                slidesToShow: 1,
                centerMode: true,
            }
        }]
    });
    $('#product_slider_02').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow prev-arrow">',
        nextArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow next-arrow">',
        responsive: [{
            breakpoint: 599,  //ブレイクポイントを指定
            settings: {
                slidesToShow: 2,
            }
        }]
    });
    $('#product_slider_03').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow prev-arrow">',
        nextArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow next-arrow">',
        responsive: [{
            breakpoint: 599,  //ブレイクポイントを指定
            settings: {
                slidesToShow: 3,
            }
        }]
    });
});

$(function () {
    function sliderSetting() {
        var width = $(window).width();
        if (width <= 750) {
            $('.contents__instagram').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                prevArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow prev-arrow">',
                nextArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow next-arrow">',
            });
        } else {
            $('.contents__instagram').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(function () {
        sliderSetting();
    });
});


// メガメニュー
$('.mega_toggle').hover(function () {
    $(this).children('.mega_toggle a').toggleClass('is-show');
    $(this).children('.mega_menu').stop().fadeToggle();
});


// ドロワー
$('.drawer__open, .drawer__close').click(function (event) {
    $('body').toggleClass('fixed');
    $('.drawer__open').toggleClass('off');
    $('.drawer__close').toggleClass('on');
    $('.drawer').toggleClass('open');
    return false;
});
$('.drawer_bottom_close').click(function (event) {
    $('body').removeClass('fixed');
    $('.drawer__open').removeClass('off');
    $('.drawer__close').removeClass('on');
    $('.drawer').removeClass('open');
    return false;
});